/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Status_Subline_Pool_OnlyInputs */



/**
* | output |
* | --- |
* | "Extra usage is disabled. Enable it below to spend beyond the pool." |
*
* @param {Usage_Status_Subline_Pool_OnlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_status_subline_pool_only = /** @type {((inputs?: Usage_Status_Subline_Pool_OnlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Status_Subline_Pool_OnlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Extra-Verbrauch ist deaktiviert. Aktivieren Sie ihn unten, um über den Pool hinaus auszugeben.")
	return /** @type {LocalizedString} */ ("Extra usage is disabled. Enable it below to spend beyond the pool.")
});